import classNames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import useRoomKolListQuery from '@/hooks/livemallclub/useRoomKolListQuery'

// Components
import Image from '@/components/common/Image'

// Styles
import styles from './style.module.scss'

const cx = classNames.bind(styles)

type KolAttendanceListProps = {
  roomId: string
}

const KolAttendanceList = ({ roomId }: KolAttendanceListProps) => {
  const { t } = useTranslation()
  const { data: kolListQueryResult } = useRoomKolListQuery({ roomId })

  if ((kolListQueryResult?.kolList?.length ?? 0) < 1) return null
  return (
    <div className={cx('kol-attendance-list')}>
      <p className={cx('kol-attendance-list__title')}>{t('KOL_ATTENDANCE_LIST_TITLE')}</p>
      <div className={cx('kol-attendance-list__list')}>
        {kolListQueryResult?.kolList?.map((kol) => (
          <div key={kol.kolId} className={cx('kol-attendance-list__list-item')}>
            <div className={cx('kol-attendance-list__list-item-avatar')}>
              <Image src={kol.headshotUrl} alt={kol.nickName} width={22} height={22} />
            </div>
            <div>{kol.nickName}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default KolAttendanceList
